import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import type { Category } from '@ilteducation/content-ref-data-types';
import CategoryImageUploader from '@/components/categories/CategoryImageUploader.vue';

type Props = {
  id: string;
  title: string;
  item: Category;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'Edit',
  props: {
    id: { default: '' },
    title: { default: '' },
    item: null
  },
  setup(__props: any) {

const props = __props as { id: string, title: string, item: Category }



const isManabuaCategory = computed(() => props.item?.subscriptionTypes?.some((sub) => sub.includes('immigrant')));

return { __sfc: true,props, isManabuaCategory, CategoryImageUploader }
}

})